<template>
    <div class="modal fade" id="tasks-made-all" tabindex="-1" aria-labelledby="tasks-made-by-all" aria-hidden="true">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Atividade geral total</h5>
                </div>
                <div class="modal-body">
                    <div class="modal-tasks-user">
                        <div class="row task-made-form">
                            <div class="form-group col-auto">
                                <date-picker
                                    v-model ="filters.startDate"
                                    format="DD/MM/YY"
                                    v-mask="'##/##/##'"
                                    v-on:change=changeFilters
                                >
                                </date-picker>
                            </div>
                            <div class="form-group col-auto">
                                <date-picker
                                    v-model ="filters.endDate"
                                    format="DD/MM/YY"
                                    v-mask="'##/##/##'"
                                    v-on:change=changeFilters
                                >
                                </date-picker>
                            </div>
                            <div class="form-group col-md-2 input-form">
                                <v-select
                                    :reduce="task =>task.id"
                                    placeholder="Atividade"
                                    label="name"
                                    v-model="filters.task"
                                    :options="tasks"
                                    v-if="tasks"
                                    v-on:input=changeFilters
                                />
                            </div>
                            <div class="form-group col-md-2 input-form">
                                <v-select
                                    :reduce="taskType => taskType.id"
                                    placeholder="Classificação"
                                    label="name"
                                    v-model="filters.taskType"
                                    :options="taskTypes"
                                    v-if="taskTypes"
                                    v-on:input=changeFilters
                                />
                            </div>
                            <div class="form-group col-md-2 input-form">
                                <v-select
                                    :reduce="customer => customer.id"
                                    placeholder="Cliente"
                                    label="name"
                                    v-model="filters.customer"
                                    :options="customers"
                                    v-if="customers"
                                    v-on:input=changeFilters
                                />
                            </div>
                            <div class="form-group col-md-2 input-form">
                                <input
                                    class="form-control"
                                    type="text"
                                    v-model="filters.note"
                                    placeholder="Observação"
                                    name="note"
                                    v-on:blur=changeFilters
                                    v-on:keyup="search"
                                >
                            </div>
                            <div class="form-group col-md-1">
                                <button v-on:click="clearFilters" class="form-control btn btn-danger">Limpar</button>
                            </div>
                        </div>
                        <br />
                        <div>
                            <table class="table table-striped">
                                <thead>
                                <tr>
                                    <th>Usuário</th>
                                    <th>Data</th>
                                    <th>Inicio</th>
                                    <th>Fim</th>
                                    <th>Total</th>
                                    <th>Atividade</th>
                                    <th>Tipo de Trabalho</th>
                                    <th>Cliente</th>
                                    <th>Observações</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <th>Total</th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th>{{ secondsToDate(total_spent) }}</th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                </tr>
                                <tr v-for="taskMade in tasksMade" :key="taskMade.id">
                                    <td>{{ taskMade.user_name }}</td>
                                    <td>
                                        <span>{{ formatDateBr(taskMade.made_at) }}</span>
                                    </td>
                                    <td>
                                        <span>{{ taskMade.started_at }}</span>
                                    </td>
                                    <td>
                                        {{ taskMade.finished_at }}
                                    </td>
                                    <td>
                                            <span>
                                                {{ secondsToDate(taskMade.time_spent) }}
                                            </span>
                                    </td>
                                    <td>
                                            <span>
                                                {{ taskMade.task_name }}
                                            </span>
                                    </td>
                                    <td>
                                            <span>
                                                {{ taskMade.task_type_name }}
                                            </span>
                                    </td>
                                    <td>
                                            <span>
                                                {{ taskMade.customer_name }}
                                            </span>
                                    </td>
                                    <td>
                                            <span>
                                                {{ taskMade.note }}
                                            </span>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <div
                                v-observe-visibility="visibilityChanged"
                                class="text-center"
                            ><i v-if="loading && hasNextPage" class="fas fa-spinner fa-pulse fa-3x fa-fw"></i></div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" v-on:click="csv">Baixar CSV</button>
                    <button type="button" class="btn btn-secondary" v-on:click="closeModal">Fechar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import DatePicker from 'vue2-datepicker'
import $ from 'jquery'
import { mapGetters } from 'vuex'

export default {
    name: 'TasksMadeAllModal',
    inject: ['eventHub'],
    components: {
        DatePicker
    },
    data () {
        return {
            loading: false,
            tasks: false,
            taskTypes: false,
            customers: false,
            users: false,
            task_id: 0,
            task_type_id: 0,
            customer_id: 0,
            tasksMade: [],
            filters: {
                startDate: new Date (),
                endDate: new Date (),
                task: '',
                taskType: '',
                customer: '',
                note: ''
            },
            stringFilters: null,
            loadStringFilters: false,
            searchTimeout: null,
            total_spent: 0,
            count: true,
            pagination: {},
            page: 1
        }
    },
    computed: {
        hasNextPage () {
            return this.pagination.current_page < this.pagination.total_pages
        },
        ...mapGetters({
            token: 'auth/token',
        }),
    },
    created () {
        this.eventHub.$on('tasks-made-all-modal', () => {
            this.clearDate()
            this.loadFormOptions()
            this.loadFilters()
            this.searchTasksMade()
            $('#tasks-made-all').modal('show')
        })
    },
    methods: {
        visibilityChanged (isVisible) {
            this.loading = true
            if (this.hasNextPage && isVisible) {
                this.page++
                if (this.loadStringFilters) {
                    this.count = false
                    this.builderFilters()
                } else {
                    this.searchTasksMade()
                }
            }
        },
        clearDate () {
            this.tasksMade = []
            this.page = 1
            this.count = true
        },
        search () {
            clearTimeout(this.searchTimeout)
            this.searchTimeout = setTimeout(() => {
                this.builderFilters()
            }, 1000)
        },
        searchTasksMade () {
            if (!this.loadStringFilters) {
                let firstDay = new Date(this.filters.startDate.getFullYear(), this.filters.startDate.getMonth(), 1);
                this.filters.startDate = firstDay
                this.stringFilters = 'page=' + this.page
                    + '&startDate=' + this.formatDate(firstDay)
                    + '&endDate=' + this.formatDate(this.filters.endDate)
            }

            this.loading = true
            axios
                .get('/api/tasks_made/all?' + this.stringFilters)
                .then((response) => {
                    this.tasksMade.push(...response.data.data)
                    this.pagination = response.data.meta.pagination
                    for (let index in this.tasksMade) {
                        if (this.tasksMade[index].made_at.length === 10) {
                            this.tasksMade[index].made_at = new Date(this.tasksMade[index].made_at + ' 12:00:00')
                        }
                    }
                    this.total_spent = 0
                    this.totalTimeSpent(this.tasksMade)
                    this.loading = false
                })
        },
        loadFilters () {
            this.filters = {
                startDate: new Date (),
                endDate: new Date (),
                task: '',
                taskType: '',
                customer: '',
                note: ''
            }
        },
        totalTimeSpent (tasks) {
            for(let i in tasks) {
                this.total_spent += tasks[i].time_spent
            }
        },
        formatDate (date) {
            return (date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2));
        },
        formatDateBr (date) {
            return (("0" + date.getDate()).slice(-2) + "/" + ("0" + (date.getMonth() + 1)).slice(-2) + "/" + date.getFullYear());
        },
        secondsToDate (seconds) {
            if (isNaN(seconds)) {
                return '00:00:00'
            }
            let hours = Math.floor(seconds / 3600)
            seconds %= 3600
            let minutes = Math.floor(seconds / 60)
            seconds = seconds % 60

            return String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0') + ':' + String(Math.floor(seconds)).padStart(2, '0')
        },
        loadFormOptions () {
            axios
                .get('/api/tasks')
                .then((response) => {
                    this.tasks = response.data
                })
            axios
                .get('/api/task_types')
                .then((response) => {
                    this.taskTypes = response.data.data
                })
            axios
                .get('/api/customers')
                .then((response) => {
                    this.customers = response.data.data
                })
        },
        changeFilters () {
            this.count = true
            this.builderFilters()
        },
        builderFilters () {
            if (this.count) {
                this.clearDate()
            }
            let filters = {
                page: this.page,
                startDate: this.formatDate(this.filters.startDate),
                endDate: this.formatDate(this.filters.endDate)
            }

            if (this.filters.task) {
                filters.task = this.filters.task
            }

            if (this.filters.taskType) {
                filters.taskType = this.filters.taskType
            }

            if (this.filters.customer) {
                filters.customer = this.filters.customer
            }

            if (this.filters.note) {
                filters.note = this.filters.note
            }
            this.builderFiltersString(filters)
        },
        builderFiltersString (filters) {
            let filterString = ''
            for (let filter in filters) {
                if (filters[filter] != null) {
                    filterString += filter + '=' + filters[filter] + '&'
                }
            }
            this.stringFilters = filterString.substring(0, filterString.length - 1)
            this.loadStringFilters = true
            this.searchTasksMade()
        },
        clearFilters () {
            this.clearDate()
            this.stringFilters = ''
            this.loadFilters()
            this.loadStringFilters = false
            this.searchTasksMade()
        },
        closeModal () {
            this.clearFilters()
            $('#tasks-made-all').modal('hide')
        },
        csv () {
            this.clearDate()
            this.builderFilters()
            window.open(process.env.VUE_APP_URL + '/api/tasks_made/report/csv?'  + this.stringFilters + '&api_token='+ this.token)
        }
    }
}
</script>

<style scoped lang="sass">
    .modal-tasks-user
        font-size: small
        height: 80vh
        overflow-y: auto


    .task-made-form
        margin-top: 10px

    .input-form
        padding-right: 0

    .loading-tasks
        font-size: 50px
        margin-top: 200px

</style>
